'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Display the custom logo provided for a site.
 *
 * Whenever we need a custom logo, it stands to reason that we would like the
 * markup to remain consistent all points. In addition, more complex logo
 * management could be implemented in the future.
 *
 * @since 0.0.6
 * @class Logo
 * @package React
 */
var Logo = function (_Component) {
    _inherits(Logo, _Component);

    /**
     * Component class constructor.
     *
     * Define the initial state of the preview modal. Essentially sets up the
     * `super` method and maintains a non-empty record for default state.
     *
     * @param object props The component properties
     * @param object context The component context
     */
    function Logo(props, context) {
        _classCallCheck(this, Logo);

        // Declare and initializze
        var _this = _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).call(this, props, context));
        // We call `super` to define `this`


        _initialiseProps.call(_this);

        var p3 = _this.context.p3;
        var p = _this.props;
        var theme = p3.theme || {};
        var src = p.src || theme.logo || '';
        var title = p.title || p3.siteName || '';

        // Define our initial state
        _this.state = {
            src: src,
            title: title,
            content: null,
            mounted: false,
            gate: 'load-logo-image'
        };
        return _this;
    }

    /**
     * Run the component routine for updated values.
     *
     * Whenever the component value changes upstream, wipe out our current
     * child component state.
     *
     * @since 0.0.6
     * @method componentWillReceiveProps
     * @param object next Incoming component properties
     * @return void
     */


    _createClass(Logo, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(next) {
            // Declare and initialize
            var p3 = this.context.p3;
            var s = this.state;
            var theme = p3.theme || {};
            var current = s.src || '';
            var src = next.src || theme.logo || '';
            var title = next.title || p3.siteName || '';

            // If the source URL did not change, do nothing
            if (current === src) return;

            // Update our state if the source changed
            this.setState({ src: src, title: title }, this.handleLogo);
        }

        /**
         * Run the component routine after the component has mounted.
         *
         * When we need to initiate routines that require the DOM to exist, we use
         * this method to invoke our functionality.
         *
         * @since 0.0.6
         * @method componentDidMount
         * @return void
         */


        /**
         * Run the component routine right before the component unmounts.
         *
         * Trying to set a state after a component has unmounted is a no-op; to
         * prevent this, we are clearing out the flood gate that sets the logo
         * image content if the component is about to unmount.
         *
         * @since 0.0.11
         * @method componentWillUnmount
         * @return void
         */


        /**
         * Asynchronously load the logo image.
         *
         * Whenever we are able and whenever we are dealing with "content" images
         * that are not required for layout, navigation, or visual confirmation,
         * we will try to load images asynchronously.
         *
         * @since 0.0.6
         * @method handleLogo
         * @return void
         * @todo Generalize this whole thing
         */

    }, {
        key: 'render',


        /**
         * Render the component function.
         *
         * The mandatory render method of the component. All it needs is the name
         * with which to produce an Logo.
         *
         * @since 0.0.6
         * @method render
         * @package React
         * @return string Markup representation of component content
         */
        value: function render() {
            // Declare and initialize
            var p3 = this.context.p3;
            var theme = this.context.theme;
            var p = this.props;
            var s = this.state;
            var src = s.src || '';
            var title = s.title || '';
            var content = s.content || null;
            var width = p.width;
            var style = p.style || {};
            var palette = theme.palette || {};
            var isSvg = src.match(/\.(svg)$/) != null;

            // Combine any extra styles
            style = _extends({}, theme.logo, style);

            // Define the styles for our placeholder title
            var titleStyle = p.titleStyle || {
                textAlign: 'center',
                fontSize: p.titleSize || 24,
                fontWeight: p.titleWeight || 600,
                lineHeight: 1,
                color: p.titleColor || palette.primary1Color
            };

            // If there is no logo, display a title of some sort
            if (!src.length) return !title.length ? null : _react2.default.createElement(
                'div',
                { style: titleStyle },
                p3.text.decode(title)
            );

            // Set the width if a width was set
            if (width) style.maxWidth = width;

            // If the width was set on an SVG, set the explicit width
            if (width && isSvg) style.width = width;

            // Return our component
            return _react2.default.createElement(
                'div',
                { style: style },
                content
            );
        }
    }]);

    return Logo;
}(_react.Component);

/**
 * Define our context values.
 *
 * Context values are passed down through the grapevine automatically. It saves
 * us from having to include parameters with every single iteration. Context
 * basically serves as a stand-in for global variables.
 *
 * @since 0.0.6
 * @type object
 */


var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.componentDidMount = function () {
        // Set our mounted state and generate the logo
        _this2.setState({ mounted: true }, _this2.handleLogo);
    };

    this.componentWillUnmount = function () {
        // Clear the gate
        _this2.state.mounted = false;
        _this2.context.p3.flood.clear(_this2.state.gate);
    };

    this.handleLogo = function () {
        // Declare and initialize
        var p3 = _this2.context.p3;
        var theme = _this2.context.theme;
        var s = _this2.state;
        var p = _this2.props;
        var src = s.src || '';
        var noAnimation = p.noAnimation || false;
        var imgClass = noAnimation ? '' : 'fade-in-grow';
        var isImage = src.match(/\.(jpeg|jpg|gif|png|svg)$/) != null;
        var imgStyle = {
            display: 'block',
            maxWidth: '100%',
            margin: '0 auto'
        };

        // If there is no URL or the URL is not an image, bail out
        if (!src.length || !isImage) return _this2.setState({ content: '' });

        // Update the state
        _this2.setState({ content: _react2.default.createElement(_CircularProgress2.default, null) }, function () {

            // Define the onload function (after a delay)
            p3.flood.set(s.gate, function () {
                // Create an image instance
                var img = new Image();

                // Create the onload function
                img.onload = function () {

                    // Swap out the content
                    var preview = _react2.default.createElement('img', { className: imgClass, src: src,
                        style: imgStyle });

                    // Update the state with the new image
                    if (_this2.state.mounted) _this2.setState({ content: preview });
                };

                // Let the user know if we cannot find the file
                img.onerror = function () {
                    if (_this2.state.mounted) _this2.setState({ content: '' });
                };

                // Set the src here (not before the `onload`)
                img.src = src;

                // We no longer need our image object
                img = null;
            }, 10);
        });
    };
};

Logo.contextTypes = {
    p3: _propTypes2.default.object,
    theme: _propTypes2.default.object
};

// Pokeball GO!
exports.default = Logo;


//////////////////
// WEBPACK FOOTER
// ./src/_components/Logo.js
// module id = 294
// module chunks = 7